module.exports = __webpack_public_path__ + "img/lugares-2.36198f93.png";